import CashOut from '../../shared/CashOut'
import CashOutContainer from './CashOutContainer'

export default CashOutContainer(CashOut)
